import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Footer from "../components/Footer1";
import Navbar from "../components/Navbar5";
import ServicesHero from "../components_service/ServicesHero";
import CoreServicesSection from "../components_service/CoreServicesSection";
import SEO from "../components/SEO";

const servicesPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Software Development and IT Services",
  url: "https://www.vishvaconnect.com/services",
  description:
    "Custom software development, website development, software testing, government portals, workflow automation, WhatsApp automation and MIS dashboard services.",
  provider: {
    "@type": "Organization",
    name: "VISHVACONNECT TECHNOLOGIES LLP",
    url: "https://www.vishvaconnect.com/",
  },
  mainEntity: {
    "@type": "ItemList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Custom Software Development",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Website Development",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Software Testing",
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Government Portal Development",
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "WhatsApp Automation",
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "Workflow Automation",
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "MIS Dashboard Development",
      },
    ],
  },
};

function ServicePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const target = document.getElementById(location.hash.slice(1));

    if (target) {
      const navbarOffset = 82;
      const targetTop =
        target.getBoundingClientRect().top + window.scrollY - navbarOffset;

      window.scrollTo({
        top: targetTop,
        behavior: "smooth",
      });
    }
  }, [location.hash]);

  return (
    <>
      <SEO
        title="Software Development & IT Services | VishvaConnect"
        description="Explore custom software and website development, software testing, government portals, WhatsApp automation, workflow automation and MIS dashboard services."
        path="/services"
        schema={servicesPageSchema}
      />
      <Navbar />

      <main>
        <ServicesHero />
        <CoreServicesSection />
      </main>

      <Footer />
    </>
  );
}

export default ServicePage;
